<template>
  <div class="notif-body">
    <div class="wording">
      <span> {{ $t('notification.notifOwner.theRequestToTransferOwnership') }} </span>
      <span class="notif-link" @click="goToCommunity">{{ truncateText(notif.payload.jsoncontent.CommunityName) }} </span>
      <span>{{ $t('notification.notifOwner.hasBeenCancelled') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotifOwnerCancel',
  props: {
    notif: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToCommunity () {
      this.$store.dispatch('showHidePanel', 'NOTIF')
      this.$store.dispatch('markNotificationIsRead', this.notif.id)
      this.$router.push({ name: 'communityPage', params: { id: this.notif.payload.jsoncontent.idCommunity } })
    },
    truncateText (str) {
      if (str.length > 50) {
        return str.substring(0, 47) + '...'
      } else {
        return str
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./NotifStyle.scss"></style>
